/***
 *
 *   TICKET REQUESTER
 *   Who opened the ticket, in the drawer's properties rail. Card chrome
 *   matches the properties card above it.
 *
 **********/

import React, { useContext } from 'react';
import Style from './owner.tailwind';
import { useTranslate } from 'app/translations';
import { Button, ViewContext, UserAvatar, initialsFromName } from 'components/lib';
import { AuthContext } from 'app/auth';
import { displayName } from 'utilities/names';

const TicketOwner = ({ ticket }) => {
    const { _t } = useTranslate();
    const viewContext = useContext(ViewContext);
    const creationHistory = ticket.histories?.find((history) => history.action_type === 'created');
    const {
        user: { permission },
    } = useContext(AuthContext);

    if (!creationHistory) return null;

    const name = displayName(creationHistory.creator_name);
    const email = creationHistory.creator_email;

    return (
        <section className={Style.container}>
            <header className={Style.header}>
                <h3 className={Style.title}>{_t('ticket.detail.requester')}</h3>
            </header>

            <div className={Style.body}>
                <div className={Style.row}>
                    <UserAvatar name={name} initials={initialsFromName(name)} size="md" />
                    <div className="min-w-0">
                        <p className={Style.name}>{name || '—'}</p>
                        {email && (
                            <a href={`mailto:${email}`} className={Style.email}>
                                {email}
                            </a>
                        )}
                    </div>
                </div>

                {permission !== 'contact' && (
                    <Button
                        text={_t('profile.label')}
                        variant="secondary"
                        size="sm"
                        className="mt-3 w-full justify-center"
                        goto={`/app/contacts/${ticket.user_id}`}
                        action={() => {
                            viewContext.pannel.hide();
                        }}
                    />
                )}
            </div>
        </section>
    );
};

export default TicketOwner;
